'use strict';

angular.module('ClinicApp').directive('userNotifications', function($q, PermissionService, OCModalUtil) {
  return {
    templateUrl: '/views/directives/_user-notifications.html',
    scope: {
      permission: '=',
    },
    link: function($scope) {
      $scope.toggleNotificationSettings = function() {
        $q.when().then(function() {
          if (!_.get($scope, 'permission.metadata.emailNotifications')) {
            return $q.when();
          }

          // Owners get all billing emails regardless of their settings
          const billingMessage = $scope.permission?.permissionType != 0
            ? ' and critical emails about billing'
            : '';
          const confirmText = `Are you sure you want to disable notifications for this user? Turning this off will disable all appointment notifications${
            billingMessage
          }.`;

          return OCModalUtil.showModal(
            'confirm',
            confirmText,
          );
        })
          .then(function() {
            var metadata = _.clone($scope.permission.metadata) || {};
            metadata.emailNotifications = !metadata.emailNotifications;
            PermissionService.updatePermissionMetadata(
              $scope.permission.modelType,
              $scope.permission.modelId,
              _.get($scope, 'permission.user.id', $scope.permission.user),
              metadata,
            ).then(function() {
              $scope.permission.metadata = metadata;
            });
          });
      };
    },
  };
});
